import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.control.layers.tree/L.Control.Layers.Tree.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet.control.layers.tree";
import "leaflet-draw";
import { usaBounds } from "./const";
import { get } from 'svelte/store'
import preferences from './preferences'

let mymap;

const pref = preferences('mapOptions', {})

const sectionals = L.tileLayer(
	"https://wms.chartbundle.com/tms/1.0.0/sec/{z}/{x}/{-y}.png",
	{ bounds: usaBounds }
);
const worldMap = L.tileLayer(
	"https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
	{
		attribution:
      "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, " +
      "AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
	}
);

const grayMap = L.tileLayer(
	"https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
	{
		attribution: '&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/about" target="_blank">OpenStreetMap</a> contributors',
		maxNativeZoom: 16,
	}
);

const grayLite = L.tileLayer(
	"https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png",
	{
		attribution: '&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/about" target="_blank">OpenStreetMap</a> contributors',
		maxNativeZoom: 16,
	}
);

const mapOptions = {
	center: [48.35672975443181, -114.15604883549791],
	zoom: 6,
	zoomControl: false,
	layers: [grayMap],
	maxBounds: [
		[-90, -180],
		[90, 180],
	],
	minZoom: 2,
	zoomSnap: 0.5,
	zoomDelta: 0.5,
	wheelPxPerZoomLevel: 480,
	fadeAnimation: false,
	...get(pref),
};

let layerControl;
const baseTree = {
	label: "Base Layers",
	children: [
		{ label: "Dark", layer: grayMap },
		{ label: "Lite", layer: grayLite },
		{ label: "Satellite", layer: worldMap },
	],
};

export const globalOverlay = {
	label: "Global",
};

const overlaysTree = {
	label: "Overlays",
	children: [{ label: "Sectionals", layer: sectionals }, globalOverlay],
};

export function addOverlay(label, layer, parent) {
	if (!parent) parent = overlaysTree;
	const segment = { label, layer };
	if (!parent.children) {
		parent.children = [];
		parent.selectAllCheckbox = true;
	}
	parent.children.push(segment);
	layerControl.setOverlayTree(overlaysTree);
	return segment;
}

export function removeOverlay(segment, parent) {
	if (!parent) parent = overlaysTree;
	const index = parent.children.indexOf(segment);
	if (index >= 0) parent.children.splice(index, 1);
	layerControl.setOverlayTree(overlaysTree);
}

const initializeMap = (element) => {
	L.Icon.Default.imagePath = '/images/'
	mymap = L.map(element, mapOptions);
	L.control.zoom({ position: "bottomright" }).addTo(mymap);
	// layerControl = L.control.layers(baseMaps, overlays, { position: 'topright' }).addTo(mymap)
	layerControl = L.control.layers
		.tree(baseTree, overlaysTree, { position: "bottomright" })
		.addTo(mymap);

	// listen for resizes
	const resizeObserver = new ResizeObserver(() => {
		mymap.invalidateSize();
	});
	resizeObserver.observe(element);

	const params = new URLSearchParams(window.location.search);

	const lat = params.get("lat");
	const lng = params.get("lng");
	const zoom = params.get("z");
	if (lat && lng) {
		mymap.setView([lat, lng], zoom || mapOptions.zoom);
	}

	mymap.on('moveend', () => {
		pref.set({
			zoom: mymap.getZoom(),
			center: mymap.getCenter(),
		})
	})
};

export function setElement(element) {
	if (element) initializeMap(element);
}

export function getMap() {
	return mymap;
}

let drawControl = null;
let drawLayer = null;
export function startDrawing() {
	drawLayer = new L.FeatureGroup().addTo(mymap);
	drawControl = new L.EditToolbar.Edit(mymap, {
		featureGroup: drawLayer,
	});
	L.drawLocal.edit.handlers.edit.tooltip.subtext = undefined;
	drawControl.enable();
}

export function endDrawing() {
	if (drawLayer) drawLayer.removeFrom(mymap);
	if (drawControl) {
		drawControl.disable();
		drawControl = null;
	}
}

export function fitBounds(bounds) {
	try {
		mymap.fitBounds(bounds)
	} catch (error) {
		console.warn('Could not fit bounds', bounds)
	}
}

export function drawRectangle(extents, options) {
	try {		
		const rect = new L.Rectangle(extents, options)
		rect.addTo(drawLayer)
		drawControl.enable()
		return rect
	} catch (error) {
		console.warn('Could not draw rectangle', extents, options)
	}
}

export function disableGlobalOverlay() {
	walkChildren(
		globalOverlay,
		(child) => child.layer && child.layer.removeFrom(mymap)
	);
}
export function enableGlobalOverlay() {
	walkChildren(
		globalOverlay,
		(child) => child.layer && child.layer.addTo(mymap)
	);
}

function walkChildren(root, callback) {
	if (!root.children) return;
	for (const child of root.children) {
		callback(child);
		walkChildren(child, callback);
	}
}
